import React from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import DraggableItem from "./DraggableItem";
import { DragDropCardList } from "../../utility/interfaces/carePlanInterfaces";
import { isTouchDevice } from "../../utility/functions/common-functions";
import { TouchBackend } from "react-dnd-touch-backend";

interface CustomDragDropProps {
  cards: DragDropCardList[];
  onMoveCard: (dragIndex: number, hoverIndex: number) => void;
}

const CustomDragDdrop: React.FC<CustomDragDropProps> = ({
  cards,
  onMoveCard,
}) => {
  return (
    <DndProvider backend={isTouchDevice() ? TouchBackend : HTML5Backend}>
      <div className="App">
        <DraggableItem cards={cards} onMoveCard={onMoveCard} />
      </div>
    </DndProvider>
  );
};

export default CustomDragDdrop;
